export const screenSizes = [
  { title: '1245px' },
  { title: '768px' },
  { title: '480px' }
];

function parseSize(value) {
  const n = parseInt(String(value).replace(/\D/g, ''), 10);
  return Number.isNaN(n) ? 0 : n;
}

export function getLandingWidth(width) {
  const w = Number(width) || 0;

  // получить числовые брейкпоинты и отсортировать по возрастанию
  const sizes = screenSizes
    .map(s => parseSize(s.title))
    .filter(n => n > 0)
    .sort((a, b) => a - b);

  if (sizes.length === 0) return w;

  const max = sizes[sizes.length - 1];

  // если ширина больше или равна максимуму — возвращаем максимум
  if (w >= max) return max;

  // вернуть первый брейкпоинт, который >= width (округление вверх)
  for (const s of sizes) {
    if (s >= w) return s;
  }

  // запасной вариант — минимальный
  return sizes[0];
}
